import { FIELD_DELIMITER } from 'js/utils/string';

export function getCapabilityData(userGroupAssessment, summaryMetrics) {
  const { pages = [] } = userGroupAssessment.assessment.document ?? {};
  const assessmentMetrics =
    summaryMetrics.assessments[userGroupAssessment.assessment.id];

  if (!assessmentMetrics) {
    return null;
  }

  if ((userGroupAssessment.assessment?.question_sets?.length ?? 0) === 0) {
    return null;
  }

  const { capabilities, capabilityElements } = pages.reduce(
    (acc, page) => {
      if (page.type !== 'capability-questions') {
        return acc;
      }

      const capabilityElements = Object.fromEntries(
        page.capabilityElements.map((element) => [element.key, element])
      );

      return {
        capabilities: {
          ...acc.capabilities,
          ...page.selectedCapabilities,
        },
        capabilityElements: {
          ...acc.capabilityElements,
          ...capabilityElements,
        },
      };
    },
    { capabilities: {}, capabilityElements: {} }
  );

  const selectedCapabilityIds = Object.keys(capabilities);

  const questions =
    Object.values(assessmentMetrics?.questionSets ?? {}).reduce((acc, qs) => {
      return {
        ...acc,
        ...qs.questions,
      };
    }, {}) ?? {};

  const metrics = Object.entries(capabilityElements).reduce(
    (acc, [, element]) => {
      const elementKey = element.key;
      return selectedCapabilityIds.reduce((idAcc, capabilityId) => {
        const questionKey = `${elementKey}${FIELD_DELIMITER}${capabilityId}`;

        const questionMetrics = questions[questionKey];

        if (!questionMetrics) {
          // The question wasn't found. This may be a selectedCapability that wasn't removed from the doc
          return idAcc;
        }

        return {
          ...idAcc,
          [elementKey]: {
            ...idAcc[elementKey],
            [capabilityId]: questionMetrics,
          },
        };
      }, acc);
    },
    {}
  );

  return {
    capabilities,
    capabilityElements,
    metrics,
    userGroupAssessment,
  };
}
